import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectMilestone } from '../../../domain/projectMilestones/projectMilestone';
import { ProjectMilestoneRepository } from '../../../infrastructure/repositories/projectMilestones/projectMilestoneRepository';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { ProjectMilestoneForm } from '../components/form/ProjectMilestoneForm';

export const UpdateProjectMilestonePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [projectMilestone, setprojectMilestone] = useState<ProjectMilestone>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Actualizar Cliente');

    useEffect(() => {
        if (id) {
            ProjectMilestoneRepository.GetProjectMilestone(id).then((response) =>
                setprojectMilestone(response)
            );
        }
    }, [id]);

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Fases - Hitos',
                route: Private_Routes.PROJECT_MILESTONE_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.UPDATE_PROJECT_MILESTONE,
            },
        ]);
    }, [lang]);

    return (
        <>
            {projectMilestone != null && (
                <ProjectMilestoneForm
                    isNewProjectMilestone={false}
                    projectMilestone={projectMilestone}
                />
            )}
        </>
    );
};
